/*
 * ar-main-banner-slider.js
 * ループ型 peek 効果対応:
 * - 前後にクローン slide を配置（Liquid 側）
 * - JS で transform を offset 1 (clone-prev 分) 込みで計算
 * - 端のクローンに到達した瞬間に transition 無しで実 slide にテレポート
 */
(function () {
  function initSlider(root) {
    if (root.dataset.arMbsInitialized === 'true') return;
    root.dataset.arMbsInitialized = 'true';

    const track = root.querySelector('[data-ar-mbs-track]');
    const realSlides = root.querySelectorAll('[data-ar-mbs-slide]');
    const dots = root.querySelectorAll('[data-ar-mbs-dot]');
    const prevBtn = root.querySelector('[data-ar-mbs-prev]');
    const nextBtn = root.querySelector('[data-ar-mbs-next]');
    const clonePrev = root.querySelector('[data-ar-mbs-clone="prev"]');
    const cloneNext = root.querySelector('[data-ar-mbs-clone="next"]');

    if (!track || realSlides.length === 0) return;

    const total = realSlides.length;
    const hasClones = !!(clonePrev && cloneNext);
    const offset = hasClones ? 1 : 0;
    let currentIndex = 0;
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval, 10) || 5000;
    let timer = null;
    let isAnimating = false;

    function setTransform(pos, withTransition) {
      track.style.transition = withTransition ? '' : 'none';
      track.style.transform = 'translateX(-' + (pos * 100) + '%)';
    }

    function syncDotsAndAria() {
      dots.forEach(function (dot, i) {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      realSlides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === currentIndex ? 'false' : 'true');
      });
    }

    function goTo(index, withTransition) {
      if (typeof withTransition === 'undefined') withTransition = true;
      currentIndex = ((index % total) + total) % total;
      setTransform(currentIndex + offset, withTransition);
      syncDotsAndAria();
    }

    function nextSlide() {
      if (isAnimating) return;
      if (!hasClones) { goTo(currentIndex + 1); return; }
      isAnimating = true;
      // last → clone-next を経由してテレポート
      if (currentIndex === total - 1) {
        setTransform(total + offset, true);
        setTimeout(function () {
          currentIndex = 0;
          setTransform(offset, false);
          syncDotsAndAria();
          isAnimating = false;
        }, 600);
      } else {
        currentIndex++;
        setTransform(currentIndex + offset, true);
        syncDotsAndAria();
        setTimeout(function () { isAnimating = false; }, 600);
      }
    }

    function prevSlide() {
      if (isAnimating) return;
      if (!hasClones) { goTo(currentIndex - 1); return; }
      isAnimating = true;
      // first → clone-prev を経由してテレポート
      if (currentIndex === 0) {
        setTransform(0, true); // clone-prev の位置
        setTimeout(function () {
          currentIndex = total - 1;
          setTransform(currentIndex + offset, false);
          syncDotsAndAria();
          isAnimating = false;
        }, 600);
      } else {
        currentIndex--;
        setTransform(currentIndex + offset, true);
        syncDotsAndAria();
        setTimeout(function () { isAnimating = false; }, 600);
      }
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(nextSlide, interval);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i, true); startAutoplay(); });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    let touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextSlide(); else prevSlide();
      }
      startAutoplay();
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.1 });
      io.observe(root);
    }

    // 初期化: 実 slide 1枚目 (offset 込み) に瞬時に位置
    goTo(0, false);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-ar-mbs]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-ar-mbs]');
    if (root) {
      root.dataset.arMbsInitialized = 'false';
      initSlider(root);
    }
  });
})();
